import { z } from 'zod'
import { UuidSchema } from '../../../utils/zodUuid'
import type { RevertTarget, RevertWorkflowRecordInput } from './revertActions'
import { ConfiguredFieldValuesInputSchema } from './configuredFieldSchemas'

const RevertTargetSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('draft') }).strict(),
  z
    .object({
      type: z.literal('status'),
      statusId: UuidSchema,
    })
    .strict(),
]) satisfies z.ZodType<RevertTarget>

/** Checks request shape before resolving current revert settings and permissions. */
export const RevertWorkflowRecordInputSchema = z
  .object({
    recordId: UuidSchema,
    target: RevertTargetSchema,
    values: ConfiguredFieldValuesInputSchema,
  })
  .strict() satisfies z.ZodType<RevertWorkflowRecordInput>
